// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.aulani),
::ng-deep .aulani {
  --checkbox-checked-color: #D04901;
  --checkbox-hover-color: #D04901;
  --secondary-other-hover: #D04901;
  --checkbox-checked-hover-color: #D04901;
  --checkbox-unchecked-hover-color: #D04901;
  --primary-dark: #382613;
  --primary-message: #867F77;
  --secondary-hover-theme: #B14308;
  --primary-dark-theme: #D04901;
  --secondary-hover: #B14308;
  --wdpr-select-all-button-background-color-hover: #B14308;
  --wdpr-select-item-color-hover: #B14308;
  --wdpr-single-select-active-color: #382613;
  --wdpr-single-select-border-width: 0 0 2px 0;
  --input-hover-border-color: #B14308;
  --input-hover-color: #B14308;
  --input-focus-border-color: #382613;
  --wdpr-single-select-border-width: 0 0 2px 0;
  --wdpr-single-select-border-color: #CCC;
  --input-border-color: #CCC;
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /*  Information MODAL STYLES FOR MOBILE
      -------------------------------
  */
}
:host-context(.aulani) *,
::ng-deep .aulani * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.aulani) *:before, :host-context(.aulani) *:after,
::ng-deep .aulani *:before,
::ng-deep .aulani *:after {
  box-sizing: border-box;
}
:host-context(.aulani) *:focus,
::ng-deep .aulani *:focus {
  outline: 1px dotted #000;
}
:host-context(.aulani) html,
:host-context(.aulani) body,
::ng-deep .aulani html,
::ng-deep .aulani body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.aulani) body,
::ng-deep .aulani body {
  width: 100%;
}
:host-context(.aulani) img,
::ng-deep .aulani img {
  width: 100%;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
::ng-deep .aulani h1,
::ng-deep .aulani h2,
::ng-deep .aulani h3,
::ng-deep .aulani h4,
::ng-deep .aulani h5 {
  margin: 0;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) span,
:host-context(.aulani) a,
:host-context(.aulani) li,
:host-context(.aulani) p,
:host-context(.aulani) input,
:host-context(.aulani) textarea,
::ng-deep .aulani h1,
::ng-deep .aulani h2,
::ng-deep .aulani h3,
::ng-deep .aulani h4,
::ng-deep .aulani h5,
::ng-deep .aulani h6,
::ng-deep .aulani span,
::ng-deep .aulani a,
::ng-deep .aulani li,
::ng-deep .aulani p,
::ng-deep .aulani input,
::ng-deep .aulani textarea {
  font-family: inherit;
}
:host-context(.aulani) .clearfix,
::ng-deep .aulani .clearfix {
  zoom: 1;
}
:host-context(.aulani) .clearfix:after,
::ng-deep .aulani .clearfix:after {
  clear: both;
}
:host-context(.aulani) .clearfix:after, :host-context(.aulani) .clearfix:before,
::ng-deep .aulani .clearfix:after,
::ng-deep .aulani .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.aulani) .float-left,
::ng-deep .aulani .float-left {
  float: left;
}
:host-context(.aulani) .float-right,
::ng-deep .aulani .float-right {
  float: right;
}
:host-context(.aulani) html,
:host-context(.aulani) body,
:host-context(.aulani) div,
:host-context(.aulani) span,
:host-context(.aulani) object,
:host-context(.aulani) iframe,
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) p,
:host-context(.aulani) blockquote,
:host-context(.aulani) pre,
:host-context(.aulani) abbr,
:host-context(.aulani) address,
:host-context(.aulani) address,
:host-context(.aulani) cite,
:host-context(.aulani) code,
:host-context(.aulani) del,
:host-context(.aulani) dfn,
:host-context(.aulani) em,
:host-context(.aulani) img,
:host-context(.aulani) ins,
:host-context(.aulani) kbd,
:host-context(.aulani) q,
:host-context(.aulani) samp,
:host-context(.aulani) small,
:host-context(.aulani) strong,
:host-context(.aulani) sub,
:host-context(.aulani) sup,
:host-context(.aulani) var,
:host-context(.aulani) b,
:host-context(.aulani) i,
:host-context(.aulani) dl,
:host-context(.aulani) dt,
:host-context(.aulani) dd,
:host-context(.aulani) ol,
:host-context(.aulani) ul,
:host-context(.aulani) li,
:host-context(.aulani) fieldset,
:host-context(.aulani) form,
:host-context(.aulani) label,
:host-context(.aulani) legend,
:host-context(.aulani) table,
:host-context(.aulani) caption,
:host-context(.aulani) tbody,
:host-context(.aulani) tfoot,
:host-context(.aulani) thead,
:host-context(.aulani) tr,
:host-context(.aulani) th,
:host-context(.aulani) td,
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) canvas,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section,
:host-context(.aulani) summary,
:host-context(.aulani) time,
:host-context(.aulani) mark,
:host-context(.aulani) audio,
:host-context(.aulani) video,
::ng-deep .aulani html,
::ng-deep .aulani body,
::ng-deep .aulani div,
::ng-deep .aulani span,
::ng-deep .aulani object,
::ng-deep .aulani iframe,
::ng-deep .aulani h1,
::ng-deep .aulani h2,
::ng-deep .aulani h3,
::ng-deep .aulani h4,
::ng-deep .aulani h5,
::ng-deep .aulani h6,
::ng-deep .aulani p,
::ng-deep .aulani blockquote,
::ng-deep .aulani pre,
::ng-deep .aulani abbr,
::ng-deep .aulani address,
::ng-deep .aulani address,
::ng-deep .aulani cite,
::ng-deep .aulani code,
::ng-deep .aulani del,
::ng-deep .aulani dfn,
::ng-deep .aulani em,
::ng-deep .aulani img,
::ng-deep .aulani ins,
::ng-deep .aulani kbd,
::ng-deep .aulani q,
::ng-deep .aulani samp,
::ng-deep .aulani small,
::ng-deep .aulani strong,
::ng-deep .aulani sub,
::ng-deep .aulani sup,
::ng-deep .aulani var,
::ng-deep .aulani b,
::ng-deep .aulani i,
::ng-deep .aulani dl,
::ng-deep .aulani dt,
::ng-deep .aulani dd,
::ng-deep .aulani ol,
::ng-deep .aulani ul,
::ng-deep .aulani li,
::ng-deep .aulani fieldset,
::ng-deep .aulani form,
::ng-deep .aulani label,
::ng-deep .aulani legend,
::ng-deep .aulani table,
::ng-deep .aulani caption,
::ng-deep .aulani tbody,
::ng-deep .aulani tfoot,
::ng-deep .aulani thead,
::ng-deep .aulani tr,
::ng-deep .aulani th,
::ng-deep .aulani td,
::ng-deep .aulani article,
::ng-deep .aulani aside,
::ng-deep .aulani canvas,
::ng-deep .aulani details,
::ng-deep .aulani figcaption,
::ng-deep .aulani figure,
::ng-deep .aulani footer,
::ng-deep .aulani header,
::ng-deep .aulani hgroup,
::ng-deep .aulani menu,
::ng-deep .aulani nav,
::ng-deep .aulani section,
::ng-deep .aulani summary,
::ng-deep .aulani time,
::ng-deep .aulani mark,
::ng-deep .aulani audio,
::ng-deep .aulani video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) img,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section,
::ng-deep .aulani article,
::ng-deep .aulani aside,
::ng-deep .aulani details,
::ng-deep .aulani figcaption,
::ng-deep .aulani figure,
::ng-deep .aulani footer,
::ng-deep .aulani header,
::ng-deep .aulani hgroup,
::ng-deep .aulani img,
::ng-deep .aulani menu,
::ng-deep .aulani nav,
::ng-deep .aulani section {
  display: block;
}
:host-context(.aulani) ol,
:host-context(.aulani) ul,
::ng-deep .aulani ol,
::ng-deep .aulani ul {
  list-style: none;
}
:host-context(.aulani) blockquote,
:host-context(.aulani) q,
::ng-deep .aulani blockquote,
::ng-deep .aulani q {
  quotes: none;
}
:host-context(.aulani) blockquote :before,
:host-context(.aulani) blockquote :after,
:host-context(.aulani) q :before,
:host-context(.aulani) q :after,
::ng-deep .aulani blockquote :before,
::ng-deep .aulani blockquote :after,
::ng-deep .aulani q :before,
::ng-deep .aulani q :after {
  content: none;
}
:host-context(.aulani) a,
::ng-deep .aulani a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.aulani) table,
::ng-deep .aulani table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.aulani) hr,
::ng-deep .aulani hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.aulani) input,
:host-context(.aulani) select,
::ng-deep .aulani input,
::ng-deep .aulani select {
  vertical-align: middle;
}
:host-context(.aulani) address,
::ng-deep .aulani address {
  font-style: normal;
}
:host-context(.aulani) input::-ms-clear,
::ng-deep .aulani input::-ms-clear {
  display: none;
}
:host-context(.aulani) button,
::ng-deep .aulani button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions p a,
::ng-deep .aulani .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions.edit p a,
::ng-deep .aulani .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.aulani) .room-request,
::ng-deep .aulani .room-request {
  padding-left: 40px;
}
:host-context(.aulani) .room-request .page-section,
::ng-deep .aulani .room-request .page-section {
  padding: 28px 0 0;
}
:host-context(.aulani) .room-request .page-section .left-section,
::ng-deep .aulani .room-request .page-section .left-section {
  float: left;
  width: calc(100% - 45px);
}
:host-context(.aulani) .room-request .page-section .left-section h3.heading,
::ng-deep .aulani .room-request .page-section .left-section h3.heading {
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCHeavy";
  padding-left: 40px;
}
:host-context(.aulani) .room-request .page-section .left-section span.di,
::ng-deep .aulani .room-request .page-section .left-section span.di {
  position: absolute;
  width: 24px;
  height: 24px;
  top: 0;
  font-size: 24px;
  color: #382613;
}
:host-context(.aulani) .room-request .page-section .right-section,
::ng-deep .aulani .room-request .page-section .right-section {
  float: right;
  text-align: right;
  width: 45px;
  margin-top: 35px;
}
:host-context(.aulani) .room-request .page-section .right-section .section-edit,
::ng-deep .aulani .room-request .page-section .right-section .section-edit {
  font-family: "InspireTWDCMedium";
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  letter-spacing: 0;
  color: #B73C00;
  font-weight: 600;
  cursor: pointer;
}
:host-context(.aulani) .room-request .page-section .right-section .section-edit:hover,
::ng-deep .aulani .room-request .page-section .right-section .section-edit:hover {
  color: #7C3813;
}
:host-context(.aulani) .room-request .page-section .right-section .section-edit:focus,
::ng-deep .aulani .room-request .page-section .right-section .section-edit:focus {
  color: #B73C00;
  outline: 2px solid #B73C00;
  outline-offset: 4px;
}
:host-context(.aulani) .room-request .select-wrap,
::ng-deep .aulani .room-request .select-wrap {
  margin: 10px 0 24px;
}
:host-context(.aulani) .room-request .select-wrap .label-wrap,
::ng-deep .aulani .room-request .select-wrap .label-wrap {
  min-width: 300px;
}
:host-context(.aulani) .room-request .select-wrap .label-wrap p,
::ng-deep .aulani .room-request .select-wrap .label-wrap p {
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 0;
  font-family: "InspireTWDCHeavy";
  color: #382613;
  margin-bottom: 7px;
}
:host-context(.aulani) .room-request .select-wrap .label-wrap .room-select-1,
::ng-deep .aulani .room-request .select-wrap .label-wrap .room-select-1 {
  background: transparent;
  margin-bottom: 19px;
  --font-light_-_font-family: InspireTWDCRoman;
}
:host-context(.aulani) .room-request .select-wrap .label-wrap .room-select-2,
::ng-deep .aulani .room-request .select-wrap .label-wrap .room-select-2 {
  background: transparent;
  --font-light_-_font-family: InspireTWDCRoman;
}
:host-context(.aulani) .room-request .requested-wrap,
::ng-deep .aulani .room-request .requested-wrap {
  margin-top: 10px;
}
:host-context(.aulani) .room-request .requested-wrap p,
::ng-deep .aulani .room-request .requested-wrap p {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  color: #382613;
}
:host-context(.aulani) .room-request .ariving-early,
::ng-deep .aulani .room-request .ariving-early {
  color: #382613;
}
:host-context(.aulani) .room-request .ariving-early span,
::ng-deep .aulani .room-request .ariving-early span {
  font-size: 18px;
  line-height: 27px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCRoman";
  display: inline-block;
  max-width: calc(100% - 40px);
  vertical-align: top;
}
:host-context(.aulani) .room-request .ariving-early span i,
::ng-deep .aulani .room-request .ariving-early span i {
  position: relative;
  top: 3px;
  font-size: 14px;
  color: #382613;
}
:host-context(.aulani) .room-request .ariving-early wdpr-checkbox,
::ng-deep .aulani .room-request .ariving-early wdpr-checkbox {
  display: inline-block;
  vertical-align: top;
}
:host-context(.aulani) .room-request .border-section,
::ng-deep .aulani .room-request .border-section {
  margin: 28px 0 0;
  width: 100%;
  height: 1px;
  background-image: none;
  border-bottom: thin solid #918F8C;
}
:host-context(.aulani) .info-modal-body,
::ng-deep .aulani .info-modal-body {
  width: 100%;
  min-height: 100vh;
  background-color: #FFF;
  z-index: 1000;
}
:host-context(.aulani) .info-modal-body .head-section,
::ng-deep .aulani .info-modal-body .head-section {
  width: 100%;
}
:host-context(.aulani) .info-modal-body .head-section .mobile-arrow .di-previous,
::ng-deep .aulani .info-modal-body .head-section .mobile-arrow .di-previous {
  position: absolute;
  top: 27px;
  font-size: 20px;
  color: #382613;
  line-height: 10px;
  font-weight: 700;
  width: 14px;
  height: 20px;
  margin-left: 10px;
}
:host-context(.aulani) .info-modal-body .head-section .mobile-arrow .di,
::ng-deep .aulani .info-modal-body .head-section .mobile-arrow .di {
  color: #382613;
}
:host-context(.aulani) .info-modal-body .head-section .mobile-arrow .di:hover,
::ng-deep .aulani .info-modal-body .head-section .mobile-arrow .di:hover {
  color: #B14308;
}
:host-context(.aulani) .info-modal-body .head-section .desktop-close .di-close-reversed,
::ng-deep .aulani .info-modal-body .head-section .desktop-close .di-close-reversed {
  display: none;
}
:host-context(.aulani) .info-modal-body .head-section h3,
::ng-deep .aulani .info-modal-body .head-section h3 {
  font-size: 20px;
  font-weight: 700;
  width: 234px;
  height: 28px;
  color: #382613;
  font-family: "InspireTWDCBlack";
  letter-spacing: 0;
  line-height: 28px;
  margin: 18px auto 14px;
}
:host-context(.aulani) .info-modal-body .horizontal-line,
::ng-deep .aulani .info-modal-body .horizontal-line {
  height: 1px;
  margin-bottom: 19.6px;
  border: 1px solid #ECF1F4;
  width: 100%;
}
:host-context(.aulani) .info-modal-body .description p,
::ng-deep .aulani .info-modal-body .description p {
  font-family: "InspireTWDCRoman";
  font-size: 16px;
  color: #382613;
  letter-spacing: 0;
  line-height: 24px;
  padding: 0px 15px 0 15px;
}
@media only screen and (max-width: 767px) {
  :host-context(.aulani) .room-request,
  ::ng-deep .aulani .room-request {
    padding-left: 32px;
  }
  :host-context(.aulani) .room-request .page-section,
  ::ng-deep .aulani .room-request .page-section {
    padding: 16px 0 0;
  }
  :host-context(.aulani) .room-request .page-section .left-section h3.heading,
  ::ng-deep .aulani .room-request .page-section .left-section h3.heading {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
    padding-left: 40px;
  }
  :host-context(.aulani) .room-request .page-section .left-section span.di,
  ::ng-deep .aulani .room-request .page-section .left-section span.di {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }
  :host-context(.aulani) .room-request .page-section .right-section,
  ::ng-deep .aulani .room-request .page-section .right-section {
    margin-top: 0px;
  }
  :host-context(.aulani) .room-request .page-section .right-section .section-edit,
  ::ng-deep .aulani .room-request .page-section .right-section .section-edit {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: 0;
  }
  :host-context(.aulani) .room-request .ariving-early span,
  ::ng-deep .aulani .room-request .ariving-early span {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) .room-request .ariving-early .ariving-early-text,
  ::ng-deep .aulani .room-request .ariving-early .ariving-early-text {
    margin-left: 12px;
  }
  :host-context(.aulani) .room-request .select-wrap-parent,
  ::ng-deep .aulani .room-request .select-wrap-parent {
    padding-left: 32px;
  }
  :host-context(.aulani) .room-request .select-wrap,
  ::ng-deep .aulani .room-request .select-wrap {
    margin: 0 0 16px;
  }
  :host-context(.aulani) .room-request .select-wrap .label-wrap,
  ::ng-deep .aulani .room-request .select-wrap .label-wrap {
    margin-top: 8px;
    min-width: calc(100vw - 150px);
  }
  :host-context(.aulani) .room-request .select-wrap .label-wrap p,
  ::ng-deep .aulani .room-request .select-wrap .label-wrap p {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) .room-request .requested-wrap,
  ::ng-deep .aulani .room-request .requested-wrap {
    margin-left: 40px;
  }
  :host-context(.aulani) .room-request .requested-wrap p,
  ::ng-deep .aulani .room-request .requested-wrap p {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) .room-request .border-section,
  ::ng-deep .aulani .room-request .border-section {
    margin: 16px 0 0;
  }
}
@media (min-width: 767px) {
  :host-context(.aulani),
  ::ng-deep .aulani {
    /* Information modal styles */
  }
  :host-context(.aulani) .room-request .page-section .left-section,
  ::ng-deep .aulani .room-request .page-section .left-section {
    width: calc(100% - 183px);
  }
  :host-context(.aulani) .room-request .select-wrap,
  ::ng-deep .aulani .room-request .select-wrap {
    padding-left: 40px;
  }
  :host-context(.aulani) .room-request .select-wrap .label-wrap,
  ::ng-deep .aulani .room-request .select-wrap .label-wrap {
    float: left;
    margin-right: 12px;
    width: 300px;
  }
  :host-context(.aulani) .room-request .select-wrap .label-wrap p,
  ::ng-deep .aulani .room-request .select-wrap .label-wrap p {
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    letter-spacing: 0;
    font-family: "InspireTWDCHeavy";
    color: #382613;
    margin-bottom: 5px;
  }
  :host-context(.aulani) .room-request .select-wrap .label-wrap .room-select-1,
  ::ng-deep .aulani .room-request .select-wrap .label-wrap .room-select-1 {
    margin-bottom: 0;
    color: #867F77;
    --font-light_-_font-family: InspireTWDCHeavy;
    --font-light_-_font-weight: 700;
  }
  :host-context(.aulani) .room-request .select-wrap .label-wrap .room-select-2,
  ::ng-deep .aulani .room-request .select-wrap .label-wrap .room-select-2 {
    color: #867F77;
    --font-light_-_font-family: InspireTWDCHeavy;
    --font-light_-_font-weight: 700;
  }
  :host-context(.aulani) .room-request .ariving-early,
  ::ng-deep .aulani .room-request .ariving-early {
    max-width: 610px;
    padding-left: 40px;
  }
  :host-context(.aulani) .room-request .ariving-early i,
  ::ng-deep .aulani .room-request .ariving-early i {
    font-size: 18px;
  }
  :host-context(.aulani) .room-request .ariving-early span,
  ::ng-deep .aulani .room-request .ariving-early span {
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) .room-request .ariving-early .ariving-early-text,
  ::ng-deep .aulani .room-request .ariving-early .ariving-early-text {
    margin-left: 12px;
  }
  :host-context(.aulani) .room-request .requested-wrap,
  ::ng-deep .aulani .room-request .requested-wrap {
    padding-left: 40px;
    margin-top: 10px;
    width: calc(100% - 183px);
  }
  :host-context(.aulani) .room-request .requested-wrap p,
  ::ng-deep .aulani .room-request .requested-wrap p {
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    letter-spacing: 0;
  }
  :host-context(.aulani) .infomation-modal,
  ::ng-deep .aulani .infomation-modal {
    position: fixed;
    top: 35%;
    right: 10%;
    bottom: 25%;
    left: 10%;
    /* z-index must be higher than .modal-background */
    z-index: 1000;
    width: 600px;
    height: 250px;
    overflow: hidden;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body,
  ::ng-deep .aulani .infomation-modal .info-modal-body {
    width: 600px;
    height: 250px;
    border: 2px solid #BBB;
    border-radius: 3px;
    padding: 30px 30px 40px 30px;
    background-color: #FFF;
    min-height: 0px;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .head-section .di,
  ::ng-deep .aulani .infomation-modal .info-modal-body .head-section .di {
    color: #382613;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .head-section .di:hover,
  ::ng-deep .aulani .infomation-modal .info-modal-body .head-section .di:hover {
    color: #B14308;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .head-section .mobile-arrow,
  ::ng-deep .aulani .infomation-modal .info-modal-body .head-section .mobile-arrow {
    display: none;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .head-section .desktop-close .di-close-reversed,
  ::ng-deep .aulani .infomation-modal .info-modal-body .head-section .desktop-close .di-close-reversed {
    display: block;
    width: 24px;
    height: 24px;
    font-size: 24px;
    line-height: 24px;
    font-weight: 700;
    float: right;
    margin-top: 6px;
    margin-right: -4.1px;
    border-radius: 2px;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .head-section h3,
  ::ng-deep .aulani .infomation-modal .info-modal-body .head-section h3 {
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    width: 281px;
    height: 33px;
    color: #382613;
    float: left;
    line-height: 33px;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .horizontal-line,
  ::ng-deep .aulani .infomation-modal .info-modal-body .horizontal-line {
    display: none;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .description,
  ::ng-deep .aulani .infomation-modal .info-modal-body .description {
    margin-top: 35px;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .description p,
  ::ng-deep .aulani .infomation-modal .info-modal-body .description p {
    line-height: 28px;
    color: #382613;
    padding: 0px;
  }
}
@media (min-width: 1024px) {
  :host-context(.aulani),
  ::ng-deep .aulani {
    /* Information modal Styles */
  }
  :host-context(.aulani) .infomation-modal,
  ::ng-deep .aulani .infomation-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* z-index must be higher than .modal-background */
    z-index: 1000;
    width: 700px;
    height: 250px;
    overflow: hidden;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body,
  ::ng-deep .aulani .infomation-modal .info-modal-body {
    width: 700px;
    height: 250px;
    min-height: 0px;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .head-section .di-close-reversed,
  ::ng-deep .aulani .infomation-modal .info-modal-body .head-section .di-close-reversed {
    display: block;
    border-radius: 2px;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .head-section .di-previous,
  ::ng-deep .aulani .infomation-modal .info-modal-body .head-section .di-previous {
    display: none;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .head-section h3,
  ::ng-deep .aulani .infomation-modal .info-modal-body .head-section h3 {
    font-size: 24px;
    font-weight: 700;
    width: 281px;
    height: 33px;
    margin: 0;
    line-height: 33px;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .description,
  ::ng-deep .aulani .infomation-modal .info-modal-body .description {
    margin-top: 35px;
    width: 640px;
  }
  :host-context(.aulani) .infomation-modal .info-modal-body .description p,
  ::ng-deep .aulani .infomation-modal .info-modal-body .description p {
    line-height: 28px;
    color: #382613;
    padding: 0px;
  }
}

:host-context(.wdw),
::ng-deep .wdw {
  --wdpr-single-select-border-width: 0px 0px 2px 0px;
  --wdpr-single-select-border-color: #A1AFC0;
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  /*  Information MODAL STYLES FOR MOBILE
      -------------------------------
  */
}
:host-context(.wdw) *,
::ng-deep .wdw * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.wdw) *:before, :host-context(.wdw) *:after,
::ng-deep .wdw *:before,
::ng-deep .wdw *:after {
  box-sizing: border-box;
}
:host-context(.wdw) *:focus,
::ng-deep .wdw *:focus {
  outline: 1px dotted #000;
}
:host-context(.wdw) html,
:host-context(.wdw) body,
::ng-deep .wdw html,
::ng-deep .wdw body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.wdw) body,
::ng-deep .wdw body {
  width: 100%;
}
:host-context(.wdw) img,
::ng-deep .wdw img {
  width: 100%;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
::ng-deep .wdw h1,
::ng-deep .wdw h2,
::ng-deep .wdw h3,
::ng-deep .wdw h4,
::ng-deep .wdw h5 {
  margin: 0;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) span,
:host-context(.wdw) a,
:host-context(.wdw) li,
:host-context(.wdw) p,
:host-context(.wdw) input,
:host-context(.wdw) textarea,
::ng-deep .wdw h1,
::ng-deep .wdw h2,
::ng-deep .wdw h3,
::ng-deep .wdw h4,
::ng-deep .wdw h5,
::ng-deep .wdw h6,
::ng-deep .wdw span,
::ng-deep .wdw a,
::ng-deep .wdw li,
::ng-deep .wdw p,
::ng-deep .wdw input,
::ng-deep .wdw textarea {
  font-family: inherit;
}
:host-context(.wdw) .clearfix,
::ng-deep .wdw .clearfix {
  zoom: 1;
}
:host-context(.wdw) .clearfix:after,
::ng-deep .wdw .clearfix:after {
  clear: both;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .clearfix:before,
::ng-deep .wdw .clearfix:after,
::ng-deep .wdw .clearfix:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.wdw) .float-left,
::ng-deep .wdw .float-left {
  float: left;
}
:host-context(.wdw) .float-right,
::ng-deep .wdw .float-right {
  float: right;
}
:host-context(.wdw) html,
:host-context(.wdw) body,
:host-context(.wdw) div,
:host-context(.wdw) span,
:host-context(.wdw) object,
:host-context(.wdw) iframe,
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) p,
:host-context(.wdw) blockquote,
:host-context(.wdw) pre,
:host-context(.wdw) abbr,
:host-context(.wdw) address,
:host-context(.wdw) address,
:host-context(.wdw) cite,
:host-context(.wdw) code,
:host-context(.wdw) del,
:host-context(.wdw) dfn,
:host-context(.wdw) em,
:host-context(.wdw) img,
:host-context(.wdw) ins,
:host-context(.wdw) kbd,
:host-context(.wdw) q,
:host-context(.wdw) samp,
:host-context(.wdw) small,
:host-context(.wdw) strong,
:host-context(.wdw) sub,
:host-context(.wdw) sup,
:host-context(.wdw) var,
:host-context(.wdw) b,
:host-context(.wdw) i,
:host-context(.wdw) dl,
:host-context(.wdw) dt,
:host-context(.wdw) dd,
:host-context(.wdw) ol,
:host-context(.wdw) ul,
:host-context(.wdw) li,
:host-context(.wdw) fieldset,
:host-context(.wdw) form,
:host-context(.wdw) label,
:host-context(.wdw) legend,
:host-context(.wdw) table,
:host-context(.wdw) caption,
:host-context(.wdw) tbody,
:host-context(.wdw) tfoot,
:host-context(.wdw) thead,
:host-context(.wdw) tr,
:host-context(.wdw) th,
:host-context(.wdw) td,
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) canvas,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section,
:host-context(.wdw) summary,
:host-context(.wdw) time,
:host-context(.wdw) mark,
:host-context(.wdw) audio,
:host-context(.wdw) video,
::ng-deep .wdw html,
::ng-deep .wdw body,
::ng-deep .wdw div,
::ng-deep .wdw span,
::ng-deep .wdw object,
::ng-deep .wdw iframe,
::ng-deep .wdw h1,
::ng-deep .wdw h2,
::ng-deep .wdw h3,
::ng-deep .wdw h4,
::ng-deep .wdw h5,
::ng-deep .wdw h6,
::ng-deep .wdw p,
::ng-deep .wdw blockquote,
::ng-deep .wdw pre,
::ng-deep .wdw abbr,
::ng-deep .wdw address,
::ng-deep .wdw address,
::ng-deep .wdw cite,
::ng-deep .wdw code,
::ng-deep .wdw del,
::ng-deep .wdw dfn,
::ng-deep .wdw em,
::ng-deep .wdw img,
::ng-deep .wdw ins,
::ng-deep .wdw kbd,
::ng-deep .wdw q,
::ng-deep .wdw samp,
::ng-deep .wdw small,
::ng-deep .wdw strong,
::ng-deep .wdw sub,
::ng-deep .wdw sup,
::ng-deep .wdw var,
::ng-deep .wdw b,
::ng-deep .wdw i,
::ng-deep .wdw dl,
::ng-deep .wdw dt,
::ng-deep .wdw dd,
::ng-deep .wdw ol,
::ng-deep .wdw ul,
::ng-deep .wdw li,
::ng-deep .wdw fieldset,
::ng-deep .wdw form,
::ng-deep .wdw label,
::ng-deep .wdw legend,
::ng-deep .wdw table,
::ng-deep .wdw caption,
::ng-deep .wdw tbody,
::ng-deep .wdw tfoot,
::ng-deep .wdw thead,
::ng-deep .wdw tr,
::ng-deep .wdw th,
::ng-deep .wdw td,
::ng-deep .wdw article,
::ng-deep .wdw aside,
::ng-deep .wdw canvas,
::ng-deep .wdw details,
::ng-deep .wdw figcaption,
::ng-deep .wdw figure,
::ng-deep .wdw footer,
::ng-deep .wdw header,
::ng-deep .wdw hgroup,
::ng-deep .wdw menu,
::ng-deep .wdw nav,
::ng-deep .wdw section,
::ng-deep .wdw summary,
::ng-deep .wdw time,
::ng-deep .wdw mark,
::ng-deep .wdw audio,
::ng-deep .wdw video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) img,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section,
::ng-deep .wdw article,
::ng-deep .wdw aside,
::ng-deep .wdw details,
::ng-deep .wdw figcaption,
::ng-deep .wdw figure,
::ng-deep .wdw footer,
::ng-deep .wdw header,
::ng-deep .wdw hgroup,
::ng-deep .wdw img,
::ng-deep .wdw menu,
::ng-deep .wdw nav,
::ng-deep .wdw section {
  display: block;
}
:host-context(.wdw) ol,
:host-context(.wdw) ul,
::ng-deep .wdw ol,
::ng-deep .wdw ul {
  list-style: none;
}
:host-context(.wdw) blockquote,
:host-context(.wdw) q,
::ng-deep .wdw blockquote,
::ng-deep .wdw q {
  quotes: none;
}
:host-context(.wdw) blockquote :before,
:host-context(.wdw) blockquote :after,
:host-context(.wdw) q :before,
:host-context(.wdw) q :after,
::ng-deep .wdw blockquote :before,
::ng-deep .wdw blockquote :after,
::ng-deep .wdw q :before,
::ng-deep .wdw q :after {
  content: none;
}
:host-context(.wdw) a,
::ng-deep .wdw a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.wdw) table,
::ng-deep .wdw table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.wdw) hr,
::ng-deep .wdw hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.wdw) input,
:host-context(.wdw) select,
::ng-deep .wdw input,
::ng-deep .wdw select {
  vertical-align: middle;
}
:host-context(.wdw) address,
::ng-deep .wdw address {
  font-style: normal;
}
:host-context(.wdw) input::-ms-clear,
::ng-deep .wdw input::-ms-clear {
  display: none;
}
:host-context(.wdw) button,
::ng-deep .wdw button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions p a,
::ng-deep .wdw .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions.edit p a,
::ng-deep .wdw .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.wdw) .room-request .page-section,
::ng-deep .wdw .room-request .page-section {
  padding: 16px 0 0;
}
:host-context(.wdw) .room-request .page-section.expanded,
::ng-deep .wdw .room-request .page-section.expanded {
  padding-top: 30px;
}
:host-context(.wdw) .room-request .page-section p,
:host-context(.wdw) .room-request .page-section h3,
::ng-deep .wdw .room-request .page-section p,
::ng-deep .wdw .room-request .page-section h3 {
  font-size: 16px;
  line-height: 28px;
  font-weight: 700;
  letter-spacing: -0.01px;
  color: #253B56;
  font-family: "InspireTWDCHeavy";
  padding-left: 40px;
}
:host-context(.wdw) .room-request .page-section p _:default:not(:root:root), :host-context(.wdw) .room-request .page-section p.safari_only,
:host-context(.wdw) .room-request .page-section h3 _:default:not(:root:root),
:host-context(.wdw) .room-request .page-section h3.safari_only,
::ng-deep .wdw .room-request .page-section p _:default:not(:root:root),
::ng-deep .wdw .room-request .page-section p.safari_only,
::ng-deep .wdw .room-request .page-section h3 _:default:not(:root:root),
::ng-deep .wdw .room-request .page-section h3.safari_only {
  font-family: "InspireTWDC";
  font-weight: 700;
}
:host-context(.wdw) .room-request .page-section .left-section,
::ng-deep .wdw .room-request .page-section .left-section {
  float: left;
  width: calc(100% - 45px);
}
:host-context(.wdw) .room-request .page-section .left-section span.di,
::ng-deep .wdw .room-request .page-section .left-section span.di {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 0;
  font-size: 21px;
  color: #253B56;
}
:host-context(.wdw) .room-request .page-section .right-section,
::ng-deep .wdw .room-request .page-section .right-section {
  float: right;
  text-align: right;
  width: 45px;
  margin-top: 2px;
}
:host-context(.wdw) .room-request .page-section .right-section .section-edit,
::ng-deep .wdw .room-request .page-section .right-section .section-edit {
  font-family: "InspireTWDCMedium";
  font-size: 12px;
  line-height: 24px;
  font-weight: 500;
  letter-spacing: 0;
  color: #1B96D5;
  cursor: pointer;
}
:host-context(.wdw) .room-request .select-wrap,
::ng-deep .wdw .room-request .select-wrap {
  margin-top: 3px;
}
:host-context(.wdw) .room-request .select-wrap .label-wrap .room-select-1,
::ng-deep .wdw .room-request .select-wrap .label-wrap .room-select-1 {
  margin-top: 13px;
}
:host-context(.wdw) .room-request .select-wrap .label-wrap .room-select-2,
::ng-deep .wdw .room-request .select-wrap .label-wrap .room-select-2 {
  margin-top: 28px;
}
:host-context(.wdw) .room-request .requested-wrap p,
::ng-deep .wdw .room-request .requested-wrap p {
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCBook";
  color: #253B56;
  padding-left: 0;
}
:host-context(.wdw) .room-request .requested-wrap p span,
::ng-deep .wdw .room-request .requested-wrap p span {
  font-size: 12px;
  line-height: 20px;
  font-weight: 700;
  letter-spacing: 0;
  font-family: "InspireTWDCHeavy";
}
:host-context(.wdw) .room-request .ariving-early,
::ng-deep .wdw .room-request .ariving-early {
  margin-top: 9px;
  color: #253B56;
}
:host-context(.wdw) .room-request .ariving-early span,
::ng-deep .wdw .room-request .ariving-early span {
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
  font-family: "InspireTWDCBook";
  display: inline-block;
  max-width: calc(100% - 35px);
  vertical-align: top;
}
:host-context(.wdw) .room-request .ariving-early span i,
::ng-deep .wdw .room-request .ariving-early span i {
  position: relative;
  top: 2px;
  font-size: 16px;
  color: #253B56;
}
:host-context(.wdw) .room-request .ariving-early wdpr-checkbox,
::ng-deep .wdw .room-request .ariving-early wdpr-checkbox {
  display: inline-block;
  vertical-align: top;
}
:host-context(.wdw) .room-request .border-section,
::ng-deep .wdw .room-request .border-section {
  margin: 30px 0 0;
  border-bottom: thin solid #D8D8D8;
  width: 100%;
}
:host-context(.wdw) .infomation-modal .info-modal-body,
::ng-deep .wdw .infomation-modal .info-modal-body {
  width: 100%;
  min-height: 100vh;
  background-color: #FFF;
  z-index: 1000;
}
:host-context(.wdw) .infomation-modal .info-modal-body .head-section,
::ng-deep .wdw .infomation-modal .info-modal-body .head-section {
  width: 100%;
}
:host-context(.wdw) .infomation-modal .info-modal-body .head-section .mobile-arrow .di-previous,
::ng-deep .wdw .infomation-modal .info-modal-body .head-section .mobile-arrow .di-previous {
  position: absolute;
  top: 27px;
  font-size: 20px;
  color: #1994D7;
  line-height: 10px;
  font-weight: 700;
  width: 14px;
  height: 20px;
  margin-left: 10px;
}
:host-context(.wdw) .infomation-modal .info-modal-body .head-section .mobile-arrow .di:hover,
::ng-deep .wdw .infomation-modal .info-modal-body .head-section .mobile-arrow .di:hover {
  color: #253B56;
}
:host-context(.wdw) .infomation-modal .info-modal-body .head-section .desktop-close .di-close-reversed,
::ng-deep .wdw .infomation-modal .info-modal-body .head-section .desktop-close .di-close-reversed {
  display: none;
}
:host-context(.wdw) .infomation-modal .info-modal-body .head-section h3,
::ng-deep .wdw .infomation-modal .info-modal-body .head-section h3 {
  font-size: 20px;
  font-weight: 700;
  width: 234px;
  height: 28px;
  color: #253B56;
  font-family: "InspireTWDCBlack";
  letter-spacing: 0;
  line-height: 28px;
  margin: 18px auto 14px;
}
:host-context(.wdw) .infomation-modal .info-modal-body .horizontal-line,
::ng-deep .wdw .infomation-modal .info-modal-body .horizontal-line {
  height: 1px;
  margin-bottom: 19.6px;
  border: 1px solid #ECF1F4;
  width: 100%;
}
:host-context(.wdw) .infomation-modal .info-modal-body .description p,
::ng-deep .wdw .infomation-modal .info-modal-body .description p {
  font-family: "InspireTWDCRoman";
  font-size: 16px;
  color: #253B56;
  letter-spacing: 0;
  line-height: 24px;
  padding: 0px 15px 0 15px;
}
@media (min-width: 767px) {
  :host-context(.wdw),
  ::ng-deep .wdw {
    /* Information modal styles */
  }
  :host-context(.wdw) .room-request .page-section,
  ::ng-deep .wdw .room-request .page-section {
    padding: 16px 0 0;
  }
  :host-context(.wdw) .room-request .page-section .left-section,
  ::ng-deep .wdw .room-request .page-section .left-section {
    width: calc(100% - 130px);
    padding-right: 28px;
  }
  :host-context(.wdw) .room-request .page-section .left-section span.di,
  ::ng-deep .wdw .room-request .page-section .left-section span.di {
    font-size: 24px;
    top: -2px;
  }
  :host-context(.wdw) .room-request .select-wrap,
  ::ng-deep .wdw .room-request .select-wrap {
    padding-left: 40px;
  }
  :host-context(.wdw) .room-request .select-wrap .label-wrap,
  ::ng-deep .wdw .room-request .select-wrap .label-wrap {
    float: left;
    margin-right: 24px;
    width: 45%;
    max-width: 240px;
  }
  :host-context(.wdw) .room-request .select-wrap .label-wrap .room-select-1,
  ::ng-deep .wdw .room-request .select-wrap .label-wrap .room-select-1 {
    margin-top: 0;
  }
  :host-context(.wdw) .room-request .select-wrap .label-wrap .room-select-2,
  ::ng-deep .wdw .room-request .select-wrap .label-wrap .room-select-2 {
    margin-top: 0;
  }
  :host-context(.wdw) .room-request .ariving-early,
  ::ng-deep .wdw .room-request .ariving-early {
    max-width: 540px;
    padding-left: 40px;
  }
  :host-context(.wdw) .room-request .requested-wrap,
  ::ng-deep .wdw .room-request .requested-wrap {
    padding-right: 28px;
    width: calc(100% - 130px);
  }
  :host-context(.wdw) .room-request .requested-wrap p,
  ::ng-deep .wdw .room-request .requested-wrap p {
    padding-left: 40px;
  }
  :host-context(.wdw) .infomation-modal,
  ::ng-deep .wdw .infomation-modal {
    position: fixed;
    top: 35%;
    right: 10%;
    bottom: 25%;
    left: 10%;
    /* z-index must be higher than .modal-background */
    z-index: 1000;
    width: 600px;
    height: 250px;
    overflow: hidden;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body,
  ::ng-deep .wdw .infomation-modal .info-modal-body {
    width: 600px;
    height: 250px;
    border: 2px solid #A0AFC0;
    border-radius: 3px;
    padding: 30px 30px 40px 30px;
    background-color: #FFF;
    min-height: 0px;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .head-section .di:hover,
  ::ng-deep .wdw .infomation-modal .info-modal-body .head-section .di:hover {
    color: #0470AB;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .head-section .mobile-arrow,
  ::ng-deep .wdw .infomation-modal .info-modal-body .head-section .mobile-arrow {
    display: none;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .head-section .desktop-close .di-close-reversed,
  ::ng-deep .wdw .infomation-modal .info-modal-body .head-section .desktop-close .di-close-reversed {
    display: block;
    width: 24px;
    height: 24px;
    font-size: 24px;
    color: #78899E;
    line-height: 24px;
    font-weight: 700;
    float: right;
    margin-top: 6px;
    margin-right: -4.1px;
    border-radius: 2px;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .head-section h3,
  ::ng-deep .wdw .infomation-modal .info-modal-body .head-section h3 {
    font-size: 24px;
    font-weight: 700;
    width: 281px;
    height: 33px;
    color: #253B56;
    margin: 0;
    float: left;
    line-height: 33px;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .horizontal-line,
  ::ng-deep .wdw .infomation-modal .info-modal-body .horizontal-line {
    display: none;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .description,
  ::ng-deep .wdw .infomation-modal .info-modal-body .description {
    margin-top: 35px;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .description p,
  ::ng-deep .wdw .infomation-modal .info-modal-body .description p {
    line-height: 28px;
    color: #253B56;
    padding: 0px;
  }
}
@media (min-width: 1024px) {
  :host-context(.wdw),
  ::ng-deep .wdw {
    /* Information modal styles */
  }
  :host-context(.wdw) .room-request .select-wrap .label-wrap,
  ::ng-deep .wdw .room-request .select-wrap .label-wrap {
    min-width: 240px;
  }
  :host-context(.wdw) .infomation-modal,
  ::ng-deep .wdw .infomation-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* z-index must be higher than .modal-background */
    z-index: 1000;
    width: 700px;
    height: 250px;
    overflow: hidden;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body,
  ::ng-deep .wdw .infomation-modal .info-modal-body {
    width: 700px;
    height: 250px;
    min-height: 0px;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .head-section .di-close-reversed,
  ::ng-deep .wdw .infomation-modal .info-modal-body .head-section .di-close-reversed {
    display: block;
    border-radius: 2px;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .head-section .di-previous,
  ::ng-deep .wdw .infomation-modal .info-modal-body .head-section .di-previous {
    display: none;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .head-section h3,
  ::ng-deep .wdw .infomation-modal .info-modal-body .head-section h3 {
    font-size: 24px;
    font-weight: 700;
    width: 281px;
    height: 33px;
    margin: 0;
    line-height: 33px;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .description,
  ::ng-deep .wdw .infomation-modal .info-modal-body .description {
    margin-top: 35px;
    width: 640px;
  }
  :host-context(.wdw) .infomation-modal .info-modal-body .description p,
  ::ng-deep .wdw .infomation-modal .info-modal-body .description p {
    line-height: 28px;
    color: #253B56;
    padding: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/room-location-request/room-location-request.component.scss","webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/app/room-location-request/room-location-request.component.aulani.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/app/room-location-request/room-location-request.component.wdw.scss"],"names":[],"mappings":"AAAA;;EAEI,iCAAA;EACA,+BAAA;EACA,gCAAA;EACA,uCAAA;EACA,yCAAA;EACA,uBAAA;EACA,0BAAA;EACA,gCAAA;EACA,6BAAA;EACA,0BAAA;EACA,wDAAA;EACA,uCAAA;EACA,0CAAA;EACA,4CAAA;EACA,mCAAA;EACA,4BAAA;EACA,mCAAA;EACA,4CAAA;EACA,uCAAA;EACA,0BAAA;ECrBJ,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;ECmHA;;GAAA;APvDA;AKrDA;;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALwDJ;AKtDI;;;EAEI,sBAAA;ALyDR;AKtDI;;EACI,wBAAA;ALyDR;AKrDA;;;;EAEI,SAAA;EACA,iBAAA;ALyDJ;AKtDA;;EACI,WAAA;ALyDJ;AKtDA;;EACI,WAAA;ALyDJ;AKtDA;;;;;;;;;;EAKI,SAAA;AL6DJ;AK1DA;;;;;;;;;;;;;;;;;;;;;;;;EAYI,oBAAA;ALwEJ;AKrEA;;EACI,OAAA;ALwEJ;AKtEI;;EACI,WAAA;ALyER;AKtEI;;;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALyER;AKrEA;;EACI,WAAA;ALwEJ;AKrEA;;EACI,YAAA;ALwEJ;AMxJA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANgOJ;AM7NA;;;;;;;;;;;;;;;;;;;;;;;;EAYI,cAAA;AN2OJ;AMxOA;;;;EAEI,gBAAA;AN4OJ;AMzOA;;;;EAEI,YAAA;AN6OJ;AM3OI;;;;;;;;EAEI,aAAA;ANmPR;AM/OA;;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ANkPJ;AM/OA;;EACI,yBAAA;EACA,iBAAA;ANkPJ;AM/OA;;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ANkPJ;AM/OA;;;;EAEI,sBAAA;ANmPJ;AMhPA;;EACI,kBAAA;ANmPJ;AM/OI;;EACI,aAAA;ANkPR;AM9OA;;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANiPJ;AM5OQ;;EACI,gBAAA;EACA,cAAA;AN+OZ;AM3OY;;EACI,cAAA;AN8OhB;AOjZA;;EACI,kBAAA;APoZJ;AOlZI;;EACI,iBAAA;APqZR;AOnZQ;;EHyBJ,WAAA;EGvBQ,wBAAA;APsZZ;AOpZY;;EHQR,eGP0B;EHQ1B,iBGRgC;EHShC,gBGTsC;EHUtC,iBGV2C;EAC/B,cNYY;EMXZ,+BCbS;EDcT,kBAAA;AP0ZhB;AOvZY;;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,eAAA;EACA,cNCY;ADyZ5B;AOtZQ;;EHQJ,YAAA;EGNQ,iBAAA;EACA,WAAA;EACA,gBAAA;APyZZ;AOvZY;;EACI,gCCnCU;EJmBtB,eGkB0B;EHjB1B,iBGiBgC;EHhBhC,gBGgBsC;EHftC,iBGe2C;EHG3C,cHvBkB;EGwBlB,gBAAA;EGFY,eAAA;AP6ZhB;AIzZI;;EACI,cALyC;AJiajD;AIzZI;;EACI,cH/Bc;EGgCd,0BAAA;EACA,mBAAA;AJ4ZR;AOlaI;;EACI,mBAAA;APqaR;AOnaQ;;EACI,gBAAA;APsaZ;AOraY;;EH9BR,eG+B0B;EH9B1B,iBG8BgC;EH7BhC,gBG6BsC;EH5BtC,iBG4B2C;EAC/B,+BClDS;EDmDT,cN3BY;EM4BZ,kBAAA;AP2ahB;AOxaY;;EACI,uBAAA;EACA,mBAAA;EACA,4CAAA;AP2ahB;AOxaY;;EACI,uBAAA;EACA,4CAAA;AP2ahB;AOtaI;;EACI,gBAAA;APyaR;AOvaQ;;EHrDJ,eGsDsB;EHrDtB,iBGqD4B;EHpD5B,gBGoDkC;EHnDlC,iBGmDuC;EAC/B,+BCvEa;EDwEb,cNlDgB;AD+d5B;AOzaI;;EACI,cNvDoB;ADme5B;AO1aQ;;EH/DJ,eGgEsB;EH/DtB,iBG+D4B;EH9D5B,gBG8DkC;EH7DlC,iBAJqE;EGkE7D,+BCjFa;EDkFb,qBAAA;EACA,4BAAA;EACA,mBAAA;APgbZ;AO9aY;;EACI,kBAAA;EACA,QAAA;EACA,eAAA;EACA,cNpEY;ADqf5B;AO7aQ;;EACI,qBAAA;EACA,mBAAA;APgbZ;AO5aI;;EACI,gBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,iCNzFgB;ADwgBxB;AOxaA;;EACI,WAAA;EACA,iBAAA;EACA,sBNtHY;EMuHZ,aAAA;AP2aJ;AOzaI;;EACI,WAAA;AP4aR;AOzaY;;EACI,kBAAA;EACA,SAAA;EACA,eAAA;EACA,cNxGY;EMyGZ,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AP4ahB;AOzaY;;EACI,cNjHY;AD6hB5B;AOzaY;;EACI,cN/GI;AD2hBpB;AOvaY;;EACI,aAAA;AP0ahB;AOtaQ;;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,cNpIgB;EMqIhB,+BC5Ja;ED6Jb,iBAAA;EACA,iBAAA;EACA,sBAAA;APyaZ;AOraI;;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;APwaR;AOpaQ;;EACI,+BC3Ka;ED4Kb,eAAA;EACA,cNvJgB;EMwJhB,iBAAA;EACA,iBAAA;EACA,wBAAA;APuaZ;AOhaA;EACI;;IACI,kBAAA;EPmaN;EOlaM;;IACI,iBAAA;EPqaV;EOlac;;IH9KZ,eG+K8B;IH9K9B,iBG8KoC;IH7KpC,gBG6K0C;IH5K1C,iBG4K+C;IAC/B,kBAAA;EPwalB;EOtac;;IACI,WAAA;IACA,YAAA;IACA,eAAA;EPyalB;EOraU;;IACI,eAAA;EPwad;EOvac;;IH3LZ,eG4L8B;IH3L9B,iBG2LoC;IH1LpC,gBG0L0C;IHzL1C,iBGyL+C;EP6ajD;EOvaU;;IHlMR,eGmM0B;IHlM1B,iBGkMgC;IHjMhC,gBGiMsC;IHhMtC,iBAJqE;EJinBvE;EO1aU;;IACI,iBAAA;EP6ad;EOzaM;;IACI,kBAAA;EP4aV;EOzaM;;IACI,gBAAA;EP4aV;EO1aU;;IACI,eAAA;IACA,8BAAA;EP6ad;EO5ac;;IHrNZ,eGsN8B;IHrN9B,iBGqNoC;IHpNpC,gBGoN0C;IHnN1C,iBAJqE;EJyoBvE;EO7aM;;IACI,iBAAA;EPgbV;EO9aU;;IH9NR,eG+N0B;IH9N1B,iBG8NgC;IH7NhC,gBG6NsC;IH5NtC,iBAJqE;EJopBvE;EOhbM;;IACI,gBAAA;EPmbV;AACF;AO/aA;EP/PA;;IOiUI,6BAAA;EPkXF;EOjbU;;IACI,yBAAA;EPobd;EOhbM;;IACI,kBAAA;EPmbV;EOjbU;;IHvOR,WAAA;IGyOY,kBAAA;IACA,YAAA;EPobd;EOlbc;;IHzPZ,eG0P8B;IHzP9B,iBGyPoC;IHxPpC,gBGwP0C;IHvP1C,iBGuP+C;IAC/B,+BC7QK;ID8QL,cNtPQ;IMuPR,kBAAA;EPwblB;EOrbc;;IACI,gBAAA;IACA,cNhQU;IMiQV,4CAAA;IACA,+BAAA;EPwblB;EOrbc;;IACI,cNtQU;IMuQV,4CAAA;IACA,+BAAA;EPwblB;EOnbM;;IACI,gBAAA;IACA,kBAAA;EPsbV;EOpbU;;IACI,eAAA;EPubd;EOpbU;;IHvRR,eGwR0B;IHvR1B,iBGuRgC;IHtRhC,gBGsRsC;IHrRtC,iBGqR2C;EP0b7C;EOvbU;;IACI,iBAAA;EP0bd;EOtbM;;IACI,kBAAA;IACA,gBAAA;IACA,yBAAA;EPybV;EOvbU;;IHrSR,eGsS0B;IHrS1B,iBGqSgC;IHpShC,gBGoSsC;IHnStC,iBGmS2C;EP6b7C;EOvbE;;IACI,eAAA;IACA,QAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IAEA,kDAAA;IACA,aAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EPybN;EOtbE;;IACI,YAAA;IACA,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,4BAAA;IACA,sBNnVQ;IMoVR,eAAA;EPybN;EOtbU;;IACI,cN/TY;EDwvB1B;EOtbU;;IACI,cN7TI;EDsvBlB;EOtbU;;IACI,aAAA;EPybd;EOrbc;;IACI,cAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;IACA,oBAAA;IACA,kBAAA;EPwblB;EOpbU;;IACI,eAAA;IACA,gBAAA;IACA,SAAA;IACA,YAAA;IACA,YAAA;IACA,cN/VY;IMgWZ,WAAA;IACA,iBAAA;EPubd;EOnbM;;IACI,aAAA;EPsbV;EOnbM;;IACI,gBAAA;EPsbV;EOpbU;;IACI,iBAAA;IACA,cN9WY;IM+WZ,YAAA;EPubd;AACF;AOlbA;EPjZA;;IOkZI,6BAAA;EPsbF;EOrbE;;IACI,eAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IAEA,kDAAA;IACA,aAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EPubN;EOpbE;;IACI,YAAA;IACA,aAAA;IACA,eAAA;EPubN;EOpbU;;IACI,cAAA;IACA,kBAAA;EPubd;EOpbU;;IACI,aAAA;EPubd;EOpbU;;IACI,eAAA;IACA,gBAAA;IACA,YAAA;IACA,YAAA;IACA,SAAA;IACA,iBAAA;EPubd;EOnbM;;IACI,gBAAA;IACA,YAAA;EPsbV;EOpbU;;IACI,iBAAA;IACA,cNnaY;IMoaZ,YAAA;EPubd;AACF;;AA91BA;;EAEI,kDAAA;EACA,0CAAA;EC7BJ,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;EGoHA;;GAAA;ATgzBA;AK75BA;;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALg6BJ;AK95BI;;;EAEI,sBAAA;ALi6BR;AK95BI;;EACI,wBAAA;ALi6BR;AK75BA;;;;EAEI,SAAA;EACA,iBAAA;ALi6BJ;AK95BA;;EACI,WAAA;ALi6BJ;AK95BA;;EACI,WAAA;ALi6BJ;AK95BA;;;;;;;;;;EAKI,SAAA;ALq6BJ;AKl6BA;;;;;;;;;;;;;;;;;;;;;;;;EAYI,oBAAA;ALg7BJ;AK76BA;;EACI,OAAA;ALg7BJ;AK96BI;;EACI,WAAA;ALi7BR;AK96BI;;;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALi7BR;AK76BA;;EACI,WAAA;ALg7BJ;AK76BA;;EACI,YAAA;ALg7BJ;AMhgCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANwkCJ;AMrkCA;;;;;;;;;;;;;;;;;;;;;;;;EAYI,cAAA;ANmlCJ;AMhlCA;;;;EAEI,gBAAA;ANolCJ;AMjlCA;;;;EAEI,YAAA;ANqlCJ;AMnlCI;;;;;;;;EAEI,aAAA;AN2lCR;AMvlCA;;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AN0lCJ;AMvlCA;;EACI,yBAAA;EACA,iBAAA;AN0lCJ;AMvlCA;;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AN0lCJ;AMvlCA;;;;EAEI,sBAAA;AN2lCJ;AMxlCA;;EACI,kBAAA;AN2lCJ;AMvlCI;;EACI,aAAA;AN0lCR;AMtlCA;;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANylCJ;AMplCQ;;EACI,gBAAA;EACA,cAAA;ANulCZ;AMnlCY;;EACI,cAAA;ANslChB;ASxvCI;;EACI,iBAAA;AT2vCR;ASzvCQ;;EACI,iBAAA;AT4vCZ;ASzvCQ;;;;ELUJ,eKRsB;ELStB,iBKT4B;ELU5B,gBKVkC;ELWlC,uBKXuC;EAC/B,cRRa;EQSb,+BDZa;ECab,kBAAA;ATgwCZ;AS9vCY;;;;;;;EAEI,0BDrBG;ECsBH,gBAAA;ATqwChB;ASjwCQ;;ELSJ,WAAA;EKPQ,wBAAA;ATowCZ;ASlwCY;;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,eAAA;EACA,cR7BS;ADkyCzB;ASjwCQ;;ELDJ,YAAA;EKGQ,iBAAA;EACA,WAAA;EACA,eAAA;ATowCZ;ASlwCY;;EACI,gCD5CU;EJmBtB,eK2B0B;EL1B1B,iBK0BgC;ELzBhC,gBKyBsC;ELxBtC,iBKwB2C;EAC/B,cAAA;EACA,eAAA;ATuwChB;ASlwCI;;EACI,eAAA;ATqwCR;ASlwCY;;EACI,gBAAA;ATqwChB;ASlwCY;;EACI,gBAAA;ATqwChB;AS/vCQ;;ELjDJ,eKkDsB;ELjDtB,iBKiD4B;ELhD5B,gBKgDkC;EL/ClC,iBK+CuC;EAC/B,8BDxEY;ECyEZ,cRnEa;EQoEb,eAAA;ATqwCZ;ASnwCY;;ELvDR,eKwD0B;ELvD1B,iBKuDgC;ELtDhC,gBKsDsC;ELrDtC,iBKqD2C;EAC/B,+BD3ES;ARo1CzB;ASpwCI;;EACI,eAAA;EACA,cR/EiB;ADs1CzB;ASrwCQ;;ELlEJ,eKmEsB;ELlEtB,iBKkE4B;ELjE5B,gBKiEkC;ELhElC,iBKgEuC;EAC/B,8BDzFY;EC0FZ,qBAAA;EACA,4BAAA;EACA,mBAAA;AT2wCZ;ASzwCY;;EACI,kBAAA;EACA,QAAA;EACA,eAAA;EACA,cR5FS;ADw2CzB;ASxwCQ;;EACI,qBAAA;EACA,mBAAA;AT2wCZ;ASvwCI;;EACI,gBAAA;EACA,iCRtGS;EQuGT,WAAA;AT0wCR;ASlwCA;;EACI,WAAA;EACA,iBAAA;EACA,sBRxHY;EQyHZ,aAAA;ATqwCJ;ASnwCI;;EACI,WAAA;ATswCR;ASnwCY;;EACI,kBAAA;EACA,SAAA;EACA,eAAA;EACA,cR5HG;EQ6HH,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ATswChB;ASnwCY;;EACI,cRxIS;AD84CzB;ASjwCY;;EACI,aAAA;ATowChB;AShwCQ;;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,cRvJa;EQwJb,+BD1Ja;EC2Jb,iBAAA;EACA,iBAAA;EACA,sBAAA;ATmwCZ;AS/vCI;;EACI,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;ATkwCR;AS9vCQ;;EACI,+BDzKa;EC0Kb,eAAA;EACA,cR1Ka;EQ2Kb,iBAAA;EACA,iBAAA;EACA,wBAAA;ATiwCZ;AS5vCA;ET/JA;;ISiNI,6BAAA;ET+sCF;ES/vCM;;IACI,iBAAA;ETkwCV;EShwCU;;IACI,yBAAA;IACA,mBAAA;ETmwCd;ESjwCc;;IACI,eAAA;IACA,SAAA;ETowClB;ES/vCM;;IACI,kBAAA;ETkwCV;EShwCU;;ILzKR,WAAA;IK2KY,kBAAA;IACA,UAAA;IACA,gBAAA;ETmwCd;ESjwCc;;IACI,aAAA;ETowClB;ESjwCc;;IACI,aAAA;ETowClB;ES/vCM;;IACI,gBAAA;IACA,kBAAA;ETkwCV;ES/vCM;;IACI,mBAAA;IACA,yBAAA;ETkwCV;EShwCU;;IACI,kBAAA;ETmwCd;ES7vCE;;IACI,eAAA;IACA,QAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IAEA,kDAAA;IACA,aAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;ET+vCN;ES5vCE;;IACI,YAAA;IACA,aAAA;IACA,yBAAA;IACA,kBAAA;IACA,4BAAA;IACA,sBR7PQ;IQ8PR,eAAA;ET+vCN;ES5vCU;;IACI,cRhQE;ED+/ChB;ES5vCU;;IACI,aAAA;ET+vCd;ES3vCc;;IACI,cAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,cR5Qa;IQ6Qb,iBAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;IACA,oBAAA;IACA,kBAAA;ET8vClB;ES1vCU;;IACI,eAAA;IACA,gBAAA;IACA,YAAA;IACA,YAAA;IACA,cR1RS;IQ2RT,SAAA;IACA,WAAA;IACA,iBAAA;ET6vCd;ESzvCM;;IACI,aAAA;ET4vCV;ESzvCM;;IACI,gBAAA;ET4vCV;ES1vCU;;IACI,iBAAA;IACA,cR1SS;IQ2ST,YAAA;ET6vCd;AACF;ASxvCA;ET9RA;;ISuSI,6BAAA;ETovCF;ES1vCU;;IACI,gBAAA;ET6vCd;ESvvCE;;IACI,eAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IAEA,kDAAA;IACA,aAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;ETyvCN;EStvCE;;IACI,YAAA;IACA,aAAA;IACA,eAAA;ETyvCN;EStvCU;;IACI,cAAA;IACA,kBAAA;ETyvCd;EStvCU;;IACI,aAAA;ETyvCd;EStvCU;;IACI,eAAA;IACA,gBAAA;IACA,YAAA;IACA,YAAA;IACA,SAAA;IACA,iBAAA;ETyvCd;ESrvCM;;IACI,gBAAA;IACA,YAAA;ETwvCV;EStvCU;;IACI,iBAAA;IACA,cRvWS;IQwWT,YAAA;ETyvCd;AACF","sourcesContent":[":host-context(.aulani),\r\n::ng-deep .aulani {\r\n    --checkbox-checked-color: #D04901;\r\n    --checkbox-hover-color: #D04901;\r\n    --secondary-other-hover: #D04901;\r\n    --checkbox-checked-hover-color: #D04901;\r\n    --checkbox-unchecked-hover-color: #D04901;\r\n    --primary-dark: #382613;\r\n    --primary-message: #867F77;\r\n    --secondary-hover-theme: #B14308;\r\n    --primary-dark-theme: #D04901;\r\n    --secondary-hover: #B14308;\r\n    --wdpr-select-all-button-background-color-hover: #B14308;\r\n    --wdpr-select-item-color-hover: #B14308;\r\n    --wdpr-single-select-active-color: #382613;\r\n    --wdpr-single-select-border-width: 0 0 2px 0;\r\n    --input-hover-border-color: #B14308;\r\n    --input-hover-color: #B14308;\r\n    --input-focus-border-color: #382613;\r\n    --wdpr-single-select-border-width: 0 0 2px 0;\r\n    --wdpr-single-select-border-color: #CCC;\r\n    --input-border-color: #CCC;\r\n    \r\n    @import './room-location-request.component.aulani';\r\n}\r\n\r\n:host-context(.wdw),\r\n::ng-deep .wdw {\r\n    --wdpr-single-select-border-width: 0px 0px 2px 0px;\r\n    --wdpr-single-select-border-color: #A1AFC0;\r\n\r\n    @import './room-location-request.component.wdw';\r\n}\r\n","/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.room-request {\r\n    padding-left: 40px;\r\n\r\n    .page-section {\r\n        padding: 28px 0 0;\r\n\r\n        .left-section {\r\n            @include float-left;\r\n            width: calc(100% - 45px);\r\n\r\n            h3.heading {\r\n                @include font(20px, 30px, 600, 0);\r\n                color: $aulani-primary-text-color;\r\n                font-family: $inspiretwdc-heavy-font;\r\n                padding-left: 40px;\r\n            }\r\n\r\n            span.di {\r\n                position: absolute;\r\n                width: 24px;\r\n                height: 24px;\r\n                top: 0;\r\n                font-size: 24px;\r\n                color: $aulani-primary-text-color;\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            @include float-right;\r\n            text-align: right;\r\n            width: 45px;\r\n            margin-top: 35px;\r\n\r\n            .section-edit {\r\n                font-family: $inspiretwdc-medium-font;\r\n\r\n                @include font(18px, 27px, 600, 0);\r\n                @include btn-link($papaya-greybg-color);\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    .select-wrap {\r\n        margin: 10px 0 24px;\r\n\r\n        .label-wrap {\r\n            min-width: 300px;\r\n            p {\r\n                @include font(12px, 16px, 700, 0);\r\n                font-family: $inspiretwdc-heavy-font;\r\n                color: $aulani-primary-text-color;\r\n                margin-bottom: 7px;\r\n            }\r\n\r\n            .room-select-1 {\r\n                background: transparent;\r\n                margin-bottom: 19px;\r\n                --font-light_-_font-family: #{$inspiretwdc-roman-font};\r\n            }\r\n\r\n            .room-select-2 {\r\n                background: transparent;\r\n                --font-light_-_font-family: #{$inspiretwdc-roman-font};\r\n            }\r\n        }\r\n    }\r\n\r\n    .requested-wrap {\r\n        margin-top: 10px;\r\n\r\n        p {\r\n            @include font(18px, 27px, 400, 0);\r\n            font-family: $inspiretwdc-roman-font;\r\n            color: $aulani-primary-text-color;\r\n        }\r\n    }\r\n\r\n    .ariving-early {\r\n        color: $aulani-primary-text-color;\r\n\r\n        span {\r\n            @include font(18px, 27px, 400);\r\n            font-family: $inspiretwdc-roman-font;\r\n            display: inline-block;\r\n            max-width: calc(100% - 40px);\r\n            vertical-align: top;\r\n\r\n            i {\r\n                position: relative;\r\n                top: 3px;\r\n                font-size: 14px;\r\n                color: $aulani-primary-text-color;\r\n            }\r\n        }\r\n\r\n        wdpr-checkbox {\r\n            display: inline-block;\r\n            vertical-align: top;\r\n        }\r\n    }\r\n\r\n    .border-section {\r\n        margin: 28px 0 0;\r\n        width: 100%;\r\n        height: 1px;\r\n        background-image: none;\r\n        border-bottom: $primary-aulani-border;\r\n    }\r\n}\r\n\r\n/*  Information MODAL STYLES FOR MOBILE\r\n    -------------------------------\r\n*/\r\n.info-modal-body {\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    background-color: $primary-color;\r\n    z-index: 1000;\r\n\r\n    .head-section {\r\n        width: 100%;\r\n\r\n        .mobile-arrow {\r\n            .di-previous {\r\n                position: absolute;\r\n                top: 27px;\r\n                font-size: 20px;\r\n                color: $aulani-primary-text-color;\r\n                line-height: 10px;\r\n                font-weight: 700;\r\n                width: 14px;\r\n                height: 20px;\r\n                margin-left: 10px;\r\n            }\r\n\r\n            .di {\r\n                color: $aulani-primary-text-color;\r\n            }\r\n\r\n            .di:hover {\r\n                color: $aulani-hover-link;\r\n            }\r\n        }\r\n\r\n        .desktop-close {\r\n            .di-close-reversed {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        h3 {\r\n            font-size: 20px;\r\n            font-weight: 700;\r\n            width: 234px;\r\n            height: 28px;\r\n            color: $aulani-primary-text-color;\r\n            font-family: $inspiretwdc-black-font;\r\n            letter-spacing: 0;\r\n            line-height: 28px;\r\n            margin: 18px auto 14px;\r\n        }\r\n    }\r\n\r\n    .horizontal-line {\r\n        height: 1px;\r\n        margin-bottom: 19.6px;\r\n        border: 1px solid #ECF1F4;\r\n        width: 100%;\r\n    }\r\n\r\n    .description {\r\n        p {\r\n            font-family: $inspiretwdc-roman-font;\r\n            font-size: 16px;\r\n            color: $aulani-primary-text-color;\r\n            letter-spacing: 0;\r\n            line-height: 24px;\r\n            padding: 0px 15px 0 15px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Mobile devices\r\n@media only screen and (max-width: 767px) {\r\n    .room-request {\r\n        padding-left: 32px;\r\n        .page-section {\r\n            padding: 16px 0 0;\r\n\r\n            .left-section {\r\n                h3.heading {\r\n                    @include font(16px, 24px, 600, 0);\r\n                    padding-left: 40px;\r\n                }\r\n                span.di {\r\n                    width: 20px;\r\n                    height: 20px;\r\n                    font-size: 20px\r\n                }\r\n            }\r\n\r\n            .right-section {\r\n                margin-top: 0px;\r\n                .section-edit {\r\n                    @include font(16px, 24px, 600, 0);\r\n                }\r\n            }\r\n        }\r\n\r\n        .ariving-early {\r\n            span {\r\n                @include font(16px, 24px, 400);\r\n            }\r\n\r\n            .ariving-early-text {\r\n                margin-left: 12px;\r\n            }\r\n        }\r\n\r\n        .select-wrap-parent {\r\n            padding-left: 32px;\r\n        }\r\n\r\n        .select-wrap {\r\n            margin: 0 0 16px;\r\n\r\n            .label-wrap {\r\n                margin-top: 8px;\r\n                min-width: calc(100vw - 150px);\r\n                p {\r\n                    @include font(16px, 24px, 400);\r\n                }\r\n            }\r\n        }\r\n\r\n        .requested-wrap {\r\n            margin-left: 40px;\r\n\r\n            p {\r\n                @include font(16px, 24px, 400);\r\n            }\r\n        }\r\n\r\n        .border-section {\r\n            margin: 16px 0 0;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .room-request {\r\n        .page-section {\r\n            .left-section {\r\n                width: calc(100% - 183px);\r\n            }\r\n        }\r\n\r\n        .select-wrap {\r\n            padding-left: 40px;\r\n\r\n            .label-wrap {\r\n                @include float-left;\r\n                margin-right: 12px;\r\n                width: 300px;\r\n\r\n                p {\r\n                    @include font(18px, 27px, 400, 0);\r\n                    font-family: $inspiretwdc-heavy-font;\r\n                    color: $aulani-primary-text-color;\r\n                    margin-bottom: 5px;\r\n                }\r\n\r\n                .room-select-1 {\r\n                    margin-bottom: 0;\r\n                    color: $aulani-secondary-text-color;\r\n                    --font-light_-_font-family: #{$inspiretwdc-heavy-font};\r\n                    --font-light_-_font-weight: 700;\r\n                }\r\n\r\n                .room-select-2 {\r\n                    color: $aulani-secondary-text-color;\r\n                    --font-light_-_font-family: #{$inspiretwdc-heavy-font};\r\n                    --font-light_-_font-weight: 700;\r\n                }\r\n            }\r\n        }\r\n\r\n        .ariving-early {\r\n            max-width: 610px;\r\n            padding-left: 40px;\r\n\r\n            i {\r\n                font-size: 18px;\r\n            }\r\n\r\n            span {\r\n                @include font(18px, 27px, 400, 0);\r\n            }\r\n\r\n            .ariving-early-text {\r\n                margin-left: 12px;\r\n            }\r\n        }\r\n\r\n        .requested-wrap {\r\n            padding-left: 40px;\r\n            margin-top: 10px;\r\n            width: calc(100% - 183px);\r\n\r\n            p {\r\n                @include font(18px, 27px, 400, 0);\r\n            }\r\n        }\r\n    }\r\n\r\n    /* Information modal styles */\r\n    .infomation-modal {\r\n        position: fixed;\r\n        top: 35%;\r\n        right: 10%;\r\n        bottom: 25%;\r\n        left: 10%;\r\n\r\n        /* z-index must be higher than .modal-background */\r\n        z-index: 1000;\r\n        width: 600px;\r\n        height: 250px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .infomation-modal .info-modal-body {\r\n        width: 600px;\r\n        height: 250px;\r\n        border: 2px solid #BBB;\r\n        border-radius: 3px;\r\n        padding: 30px 30px 40px 30px;\r\n        background-color: $primary-color;\r\n        min-height: 0px;\r\n\r\n        .head-section {\r\n            .di {\r\n                color: $aulani-primary-text-color;\r\n            }\r\n\r\n            .di:hover {\r\n                color: $aulani-hover-link;\r\n            }\r\n\r\n            .mobile-arrow {\r\n                display: none;\r\n            }\r\n\r\n            .desktop-close {\r\n                .di-close-reversed {\r\n                    display: block;\r\n                    width: 24px;\r\n                    height: 24px;\r\n                    font-size: 24px;\r\n                    line-height: 24px;\r\n                    font-weight: 700;\r\n                    float: right;\r\n                    margin-top: 6px;\r\n                    margin-right: -4.1px;\r\n                    border-radius: 2px;\r\n                }\r\n            }\r\n\r\n            h3 {\r\n                font-size: 24px;\r\n                font-weight: 700;\r\n                margin: 0;\r\n                width: 281px;\r\n                height: 33px;\r\n                color: $aulani-primary-text-color;\r\n                float: left;\r\n                line-height: 33px;\r\n            }\r\n        }\r\n\r\n        .horizontal-line {\r\n            display: none;\r\n        }\r\n\r\n        .description {\r\n            margin-top: 35px;\r\n\r\n            p {\r\n                line-height: 28px;\r\n                color: $aulani-primary-text-color;\r\n                padding: 0px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n    /* Information modal Styles */\r\n    .infomation-modal {\r\n        position: fixed;\r\n        top: 50%;\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n\r\n        /* z-index must be higher than .modal-background */\r\n        z-index: 1000;\r\n        width: 700px;\r\n        height: 250px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .infomation-modal .info-modal-body {\r\n        width: 700px;\r\n        height: 250px;\r\n        min-height: 0px;\r\n\r\n        .head-section {\r\n            .di-close-reversed {\r\n                display: block;\r\n                border-radius: 2px;\r\n            }\r\n\r\n            .di-previous {\r\n                display: none;\r\n            }\r\n\r\n            h3 {\r\n                font-size: 24px;\r\n                font-weight: 700;\r\n                width: 281px;\r\n                height: 33px;\r\n                margin: 0;\r\n                line-height: 33px;\r\n            }\r\n        }\r\n\r\n        .description {\r\n            margin-top: 35px;\r\n            width: 640px;\r\n\r\n            p {\r\n                line-height: 28px;\r\n                color: $aulani-primary-text-color;\r\n                padding: 0px;\r\n            }\r\n        }\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.room-request {\r\n    .page-section {\r\n        padding: 16px 0 0;\r\n\r\n        &.expanded {\r\n            padding-top: 30px;\r\n        }\r\n\r\n        p,\r\n        h3 {\r\n            @include font(16px, 28px, 700, -0.01px);\r\n            color: $wdw-primary-text-color;\r\n            font-family: $inspiretwdc-heavy-font;\r\n            padding-left: 40px;\r\n\r\n            _:default:not(:root:root),\r\n            &.safari_only {\r\n                font-family: $inspiretwdc-font;\r\n                font-weight: 700;\r\n            }\r\n        }\r\n\r\n        .left-section {\r\n            @include float-left;\r\n            width: calc(100% - 45px);\r\n\r\n            span.di {\r\n                position: absolute;\r\n                width: 30px;\r\n                height: 30px;\r\n                top: 0;\r\n                font-size: 21px;\r\n                color: $wdw-primary-text-color;\r\n            }\r\n        }\r\n\r\n        .right-section {\r\n            @include float-right;\r\n            text-align: right;\r\n            width: 45px;\r\n            margin-top: 2px;\r\n\r\n            .section-edit {\r\n                font-family: $inspiretwdc-medium-font;\r\n\r\n                @include font(12px, 24px, 500, 0);\r\n                color: #1B96D5;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    .select-wrap {\r\n        margin-top: 3px;\r\n\r\n        .label-wrap {\r\n            .room-select-1 {\r\n                margin-top: 13px;\r\n            }\r\n\r\n            .room-select-2 {\r\n                margin-top: 28px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .requested-wrap {\r\n        p {\r\n            @include font(12px, 20px, 400, 0);\r\n            font-family: $inspiretwdc-book-font;\r\n            color: $wdw-primary-text-color;\r\n            padding-left: 0;\r\n\r\n            span {\r\n                @include font(12px, 20px, 700, 0);\r\n                font-family: $inspiretwdc-heavy-font;\r\n            }\r\n        }\r\n    }\r\n\r\n    .ariving-early {\r\n        margin-top: 9px;\r\n        color: $wdw-primary-text-color;\r\n\r\n        span {\r\n            @include font(12px, 20px, 400, 0);\r\n            font-family: $inspiretwdc-book-font;\r\n            display: inline-block;\r\n            max-width: calc(100% - 35px);\r\n            vertical-align: top;\r\n\r\n            i {\r\n                position: relative;\r\n                top: 2px;\r\n                font-size: 16px;\r\n                color: $wdw-primary-text-color;\r\n            }\r\n        }\r\n\r\n        wdpr-checkbox {\r\n            display: inline-block;\r\n            vertical-align: top;\r\n        }\r\n    }\r\n\r\n    .border-section {\r\n        margin: 30px 0 0;\r\n        border-bottom: $primary-border;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n/*  Information MODAL STYLES FOR MOBILE\r\n    -------------------------------\r\n*/\r\n\r\n.infomation-modal .info-modal-body {\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    background-color: $primary-color;\r\n    z-index: 1000;\r\n\r\n    .head-section {\r\n        width: 100%;\r\n\r\n        .mobile-arrow {\r\n            .di-previous {\r\n                position: absolute;\r\n                top: 27px;\r\n                font-size: 20px;\r\n                color: $primary-wdw-link;\r\n                line-height: 10px;\r\n                font-weight: 700;\r\n                width: 14px;\r\n                height: 20px;\r\n                margin-left: 10px;\r\n            }\r\n\r\n            .di:hover {\r\n                color: $wdw-primary-text-color;\r\n            }\r\n        }\r\n\r\n        .desktop-close {\r\n            .di-close-reversed {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        h3 {\r\n            font-size: 20px;\r\n            font-weight: 700;\r\n            width: 234px;\r\n            height: 28px;\r\n            color: $wdw-primary-text-color;\r\n            font-family: $inspiretwdc-black-font;\r\n            letter-spacing: 0;\r\n            line-height: 28px;\r\n            margin: 18px auto 14px;\r\n        }\r\n    }\r\n\r\n    .horizontal-line {\r\n        height: 1px;\r\n        margin-bottom: 19.6px;\r\n        border: 1px solid #ECF1F4;\r\n        width: 100%;\r\n    }\r\n\r\n    .description {\r\n        p {\r\n            font-family: $inspiretwdc-roman-font;\r\n            font-size: 16px;\r\n            color: $wdw-primary-text-color;\r\n            letter-spacing: 0;\r\n            line-height: 24px;\r\n            padding: 0px 15px 0 15px;\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .room-request {\r\n        .page-section {\r\n            padding: 16px 0 0;\r\n\r\n            .left-section {\r\n                width: calc(100% - 130px);\r\n                padding-right: 28px;\r\n\r\n                span.di {\r\n                    font-size: 24px;\r\n                    top: -2px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .select-wrap {\r\n            padding-left: 40px;\r\n\r\n            .label-wrap {\r\n                @include float-left;\r\n                margin-right: 24px;\r\n                width: 45%;\r\n                max-width: 240px;\r\n\r\n                .room-select-1 {\r\n                    margin-top: 0;\r\n                }\r\n\r\n                .room-select-2 {\r\n                    margin-top: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        .ariving-early {\r\n            max-width: 540px;\r\n            padding-left: 40px;\r\n        }\r\n\r\n        .requested-wrap {\r\n            padding-right: 28px;\r\n            width: calc(100% - 130px);\r\n\r\n            p {\r\n                padding-left: 40px;\r\n            }\r\n        }\r\n    }\r\n\r\n    /* Information modal styles */\r\n    .infomation-modal {\r\n        position: fixed;\r\n        top: 35%;\r\n        right: 10%;\r\n        bottom: 25%;\r\n        left: 10%;\r\n\r\n        /* z-index must be higher than .modal-background */\r\n        z-index: 1000;\r\n        width: 600px;\r\n        height: 250px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .infomation-modal .info-modal-body {\r\n        width: 600px;\r\n        height: 250px;\r\n        border: 2px solid #A0AFC0;\r\n        border-radius: 3px;\r\n        padding: 30px 30px 40px 30px;\r\n        background-color: $primary-color;\r\n        min-height: 0px;\r\n\r\n        .head-section {\r\n            .di:hover {\r\n                color: $secondary-color;\r\n            }\r\n\r\n            .mobile-arrow {\r\n                display: none;\r\n            }\r\n\r\n            .desktop-close {\r\n                .di-close-reversed {\r\n                    display: block;\r\n                    width: 24px;\r\n                    height: 24px;\r\n                    font-size: 24px;\r\n                    color: $wdw-primary-message-text-color;\r\n                    line-height: 24px;\r\n                    font-weight: 700;\r\n                    float: right;\r\n                    margin-top: 6px;\r\n                    margin-right: -4.1px;\r\n                    border-radius: 2px;\r\n                }\r\n            }\r\n\r\n            h3 {\r\n                font-size: 24px;\r\n                font-weight: 700;\r\n                width: 281px;\r\n                height: 33px;\r\n                color: $wdw-primary-text-color;\r\n                margin: 0;\r\n                float: left;\r\n                line-height: 33px;\r\n            }\r\n        }\r\n\r\n        .horizontal-line {\r\n            display: none;\r\n        }\r\n\r\n        .description {\r\n            margin-top: 35px;\r\n\r\n            p {\r\n                line-height: 28px;\r\n                color: $wdw-primary-text-color;\r\n                padding: 0px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n    .room-request {\r\n        .select-wrap {\r\n            .label-wrap {\r\n                min-width: 240px;\r\n            }\r\n        }\r\n    }\r\n\r\n    /* Information modal styles */\r\n    .infomation-modal {\r\n        position: fixed;\r\n        top: 50%;\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n\r\n        /* z-index must be higher than .modal-background */\r\n        z-index: 1000;\r\n        width: 700px;\r\n        height: 250px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .infomation-modal .info-modal-body {\r\n        width: 700px;\r\n        height: 250px;\r\n        min-height: 0px;\r\n\r\n        .head-section {\r\n            .di-close-reversed {\r\n                display: block;\r\n                border-radius: 2px;\r\n            }\r\n\r\n            .di-previous {\r\n                display: none;\r\n            }\r\n\r\n            h3 {\r\n                font-size: 24px;\r\n                font-weight: 700;\r\n                width: 281px;\r\n                height: 33px;\r\n                margin: 0;\r\n                line-height: 33px;\r\n            }\r\n        }\r\n\r\n        .description {\r\n            margin-top: 35px;\r\n            width: 640px;\r\n\r\n            p {\r\n                line-height: 28px;\r\n                color: $wdw-primary-text-color;\r\n                padding: 0px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
